export const validatePassword = (password) => {
    //let regex = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/
    let regex = /^(?=.*[a-zA-Z])(?=.*[0-9])/
    return regex.test(password)
}
